module.exports = __webpack_public_path__ + "assets/img/hexagon.cd52ebdf.svg";